import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus13() {
  return (
    <BusDetailsCard
      busId="bus13"
      title="Bus 13 - Route Details"
      busName="Bus 13"
      vehicleNo="TN74M3234"
      backTo="/?buses=1"
    />
  );
}